export class OAuthError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OAuthError';
    }
}
//# sourceMappingURL=oauth_error.js.map